import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api.syxlabs.com/v1";

export const api = axios.create({
  baseURL: API_BASE_URL,
});

export const getJobs = async () => {
  const response = await api.get("/jobs");
  return response.data;
};

